export default [{
    name: 'name',
    label: '_name_',
    disabled: true,
    type: 'text',
    additionalStyle: 'col-xs-3 padding-right',
    labelStyle: 'label-width padding-right',
    inputStyle: true
}, {
    name: 'price',
    label: '_price_',
    disabled: false,
    type: 'number',
    additionalStyle: 'col-xs-2 padding-right',
    labelStyle: 'padding-right',
    inputStyle: true
}, {
    name: 'driverExpenses',
    label: '_driver_expenses_',
    disabled: false,
    type: 'number',
    additionalStyle: 'col-xs-2 padding-right',
    labelStyle: 'padding-right',
    inputStyle: true
}, {
    name: 'partnerDebt',
    label: '_partner_debt_',
    disabled: false,
    type: 'number',
    additionalStyle: 'col-xs-2 padding-right',
    labelStyle: 'padding-right',
    inputStyle: true
}, {
    name: 'quantity',
    label: '_quantity_',
    disabled: false,
    type: 'number',
    additionalStyle: 'col-xs-2 padding-right',
    labelStyle: 'padding-right',
    inputStyle: true
}];